import { SVGProps, useEffect, useState } from 'react';
import { CheckIcon } from '@lyse-as/formds-react/lib/icon/common';
import styles from './copy-button.module.scss';

// `content_copy` has no formds v3 equivalent, so it's inlined as its Material Design glyph.
const ContentCopyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
      fill="currentColor"
    />
  </svg>
);

type CopyButtonProps = {
  value: string;
  title: string;
  callback: () => void;
};

export const CopyButton: React.FC<CopyButtonProps> = ({ value, title, callback }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (copied) setCopied(false);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [copied]);

  const handleCopy = () => {
    setCopied(true);
    navigator.clipboard.writeText(value);
    callback();
  };

  return (
    <div className={styles.container}>
      <button className={styles.button} onClick={handleCopy} title={title} aria-label={title}>
        <ContentCopyIcon className={!copied ? styles.copyIcon : styles.hidden} />
        <CheckIcon className={copied ? styles.checkIcon : styles.hidden} />
      </button>
    </div>
  );
};
